<style>
  .circle_green{
    width: 50px;
    height: 50px;
    margin: 5px;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    background: #28C76F;
  }
  .circle_warning{
    width: 50px;
    height: 50px;
    margin: 5px;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    background: #FF9F43;
  }
  .circle_red{
    width: 50px;
    height: 50px;
    margin: 5px;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    background: #EA5455;
  }
  .circle_blue{
    width: 50px;
    height: 50px;
    margin: 5px;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    background: #0cb0f1;
  }
  .circle_blue_disabled{
    width: 50px;
    height: 50px;
    margin: 5px;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    background: rgb(12,176,241,0.1)
  }
  .circle_green_disabled{
    width: 50px;
    height: 50px;
    margin: 5px;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    background: rgb(40,199,111,0.1)
  }
  .circle_warning_disabled{
    width: 50px;
    height: 50px;
    margin: 5px;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    background-color:rgb(255,159,67,0.1)
  }
  .circle_red_disabled{
    width: 50px;
    height: 50px;
    margin: 5px;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    background-color: rgba(161, 63, 63, 0.1);
  }
  .label_value {
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    margin-top: 10px;
    margin-right: 30px;
  }
  @media (max-width: 1590px) {
    .label_value {
      font-size: 20px;
    }
  }
  @media (max-width: 1450px) {
    .label_value {
      font-size: 14px;
    }
  }
  @media (max-width: 1200px) {
    .label_value {
      font-size: 15px;
    }
  }
  @media (max-width: 920px) {
    .label_value {
      font-size: 12px;
    }
  }
  @media (max-width: 766px) {
    .label_value {
      font-size: 24px;
    }
  }
  .label_value_alert {
    text-align: center;
    font-weight: bold;
    font-size: 10px;
    margin-top: 10px;
    margin-right: 30px;
  }
  .danger {
    color: #EA5455;
  }
  .success {
    color: #28C76F;
  }
  .warning {
    color: #FF9F43;
  }
  .blue {
    color: #0cb0f1;
  }
  .title {
    text-align: center;
    font-weight: bold;
    color: #03BEE5;
  }
  .message {
    font-size: 10px;
    text-align: center;
  }
</style>
<template>
  <div>
    <div class="title">
      <span>{{this.title}}</span>
    </div>
    <div class="flex flex-wrap p-2">
      <div class="w-full sm:w-1/1 md:w-1/1 lg:w-1/3 xl:w-1/3 " v-if="this.deviceType === 'C'">
        <div :class="this.circle_green" class="p-4 m-auto mb-2">
          <img :src="getImgUrl('co2_white','svg')" class="m-auto w-8" alt="ícono"/>
        </div>
        <div :class="this.circle_warning" class="p-4 m-auto mb-2">
          <img :src="getImgUrl('co2_white','svg')" class="m-auto w-8" alt="ícono"/>
        </div>
        <div :class="this.circle_red" class="p-4 m-auto">
          <img :src="getImgUrl('co2_white','svg')" class="m-auto w-8" alt="ícono"/>
        </div>
      </div>
      <div class="w-full sm:w-1/1 md:w-1/1 lg:w-1/3 xl:w-1/3 " v-if="this.deviceType !== 'C'">
        <div :class="this.circle_red" class="p-3 m-auto mb-2">
          <img :src="getImgUrl(this.deviceType,'svg')" class="m-auto w-8" alt="ícono"/>
        </div>
        <div :class="this.circle_green" class="p-3 m-auto mb-2">
          <img :src="getImgUrl(this.deviceType,'svg')" class="m-auto w-8" alt="ícono"/>
        </div>
        <div :class="this.circle_blue" class="p-3 m-auto mb-2">
          <img :src="getImgUrl(this.deviceType,'svg')" class="m-auto w-8" alt="ícono"/>
        </div>
      </div>
      <div class="w-full sm:w-1/1 md:w-1/1 lg:w-2/3 xl:w-2/3 p-4">
        <div class="label_value w-full">
          <span :class="this.getRangeColor()">{{ parseFloat(value).toFixed(2) }}{{unit}}</span> <br>
        </div>
        <div class="label_value_alert w-full">
          <span :class="this.getRangeColor()">{{ this.getAlert() }}</span>
        </div><br>
        <div v-if="this.type === 'Q' && this.deviceType === 'C'" class="message">
          <img :src="this.getImgUrl(`${this.getImageAlert()}_${this.getRangeColor()}`,'svg')" class="m-auto w-8" alt="ícono"/>
          <span :class="this.getRangeColor()">{{ this.getTextAlert() }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    min: {
      type: [Number],
      required: true
    },
    max: {
      type: [Number],
      required: true
    },
    alertMin: {
      type: [Number],
      required: true
    },
    alertMax: {
      type: [Number],
      required: true
    },
    warning: {
      type: [Number]
    },
    title: {
      type: [String],
      default: ''
    },
    value: {
      type: [Number],
      required: true
    },
    unit: {
      type: [String],
      required: true
    },
    type: {
      type: [String],
      default: ''
    },
    deviceType: {
      type: [String],
      default: ''
    }
  },
  data () {
    return {
      app: this,
      imageAlert: '',
      circle_green: 'circle_green_disabled',
      circle_warning: 'circle_warning_disabled',
      circle_red: 'circle_red_disabled',
      circle_blue: 'circle_blue_disabled',
      color: ''
    }
  },
  methods: {
    getAlert () {
      let alert = ''
      this.color = 'success'
      if (this.type === 'V') {
        if (this.value <= this.alertMin) {
          alert = this.$t('Labels.RiskFree')
        } else if (this.value <= this.warning) {
          alert = this.$t('Labels.RiskModerate')
        } else if (this.value > this.warning) {
          alert = this.$t('Labels.RiskHight')
        }
      } else if (this.type === 'Q') {
        if (this.value <= this.alertMin) {
          alert = this.$t('Labels.GoodQuality')
        } else if (this.value <= this.warning) {
          alert = this.$t('Labels.BadQuality')
        } else if (this.value > this.warning) {
          alert = this.$t('Labels.PoorQuality')
        }
      } else {
        if (this.value > this.alertMax) {
          alert = this.$t('Labels.HighRank')
        } else if (this.value >= this.alertMin && this.value <= this.alertMax) {
          alert = this.$t('Labels.CorrectRange')
        } else {
          alert = this.$t('Labels.LowRange')
        }
      }
      return alert
    },
    getRangeColor () {
      let color = 'success'
      if (this.deviceType === 'C') {
        if (this.value <= this.alertMin) {
          color = 'success'
          this.circle_green = 'circle_green'
        } else if (this.value <= this.warning) {
          color = 'warning'
          this.circle_warning = 'circle_warning'
        } else if (this.value > this.warning) {
          color = 'danger'
          this.circle_red = 'circle_red'
        }
        return color
      } else {
        if (this.value > this.alertMax) {
          color = 'danger'
          this.circle_red = 'circle_red'
        } else if (this.value >= this.alertMin && this.value <= this.alertMax) {
          color = 'success'
          this.circle_green = 'circle_green'
        } else {
          color = 'blue'
          this.circle_blue = 'circle_blue'
        }
        return color
      }
    },
    getImageAlert () {
      let imageAlert = ''
      if (this.type === 'Q') {
        if (this.value < 600) {
          imageAlert = 'smile'
        } else if (this.value < 1000) {
          imageAlert = 'ventilador'
        } else if (this.value >= 1000 && this.value < 2000) {
          imageAlert = 'suenio'
        } else if (this.value >= 2000) {
          imageAlert = 'cabeza'
        }
      }
      return imageAlert
    },
    getTextAlert () {
      let message = ''
      if (this.type === 'Q') {
        if (this.value >= 1000 && this.value < 2000) {
          message = this.$t('Labels.CanSleep')
        } else if (this.value >= 2000) {
          message = this.$t('Labels.CanHeadache')
        }
      }
      return message
    },
    getImgUrl (type, extension) {
      if (!type) {
        return ''
      }
      const img = {
        C: 'co2_white',
        T: 'temperature_white',
        H: 'humedad_white'
      }
      let name = ''
      if (type.length === 1) {
        name = img[type]
      } else {
        name = type
      }
      const images = require.context('@/assets/images/icons/', false)
      return images(`./${name}.${extension}`)
    }
  }
}
</script>
